/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_Anatomy_HintInputs */

const en_directory_detail_score_anatomy_hint = /** @type {(inputs: Directory_Detail_Score_Anatomy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scores indicate documented product strength, not a hands-on guarantee.`)
};

const zh_directory_detail_score_anatomy_hint = /** @type {(inputs: Directory_Detail_Score_Anatomy_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分反映可查证的产品资料，不代表实际使用效果保证。`)
};

/**
* | output |
* | --- |
* | "Scores indicate documented product strength, not a hands-on guarantee." |
*
* @param {Directory_Detail_Score_Anatomy_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_anatomy_hint = /** @type {((inputs?: Directory_Detail_Score_Anatomy_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Anatomy_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_anatomy_hint(inputs)
	return zh_directory_detail_score_anatomy_hint(inputs)
});
export { directory_detail_score_anatomy_hint as "directory.detail.score_anatomy_hint" }